<span class="theme-sports-priceboost priceboost-signpost-icon"></span>
@if (showPriceBoostCount && count) {
    <span class="priceboost-signpost-count">
        <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="count" />
    </span>
}
